<template>
<!-- eslint-disable max-len -->
<div class="almas-radar">
  <img v-if="highlightedIndex === 0"
    class="highlight"
    src="/static/reports/almasradar/redhighlighted.png"
  />
  <img v-if="highlightedIndex === 1"
    class="highlight"
    src="/static/reports/almasradar/bluehighlighted.png"
  />
  <img v-if="highlightedIndex === 2"
    class="highlight"
    src="/static/reports/almasradar/yellowhighlighted.png"
  />
  <div class="label red">
    <img class="label-icon red"
      :src="`/static/reports/archetypes/${
        (icons && icons.length > 0) ? icons[0] : 'Icon_Curious'
      }.png`"
    />
    <div class="label-text red">
      <span>{{(labels && labels.length > 0) ? labels[0] : 'THE CURIOUS'}}</span>
    </div>
  </div>
  <div class="label blue">
    <img class="label-icon blue"
      :src="`/static/reports/archetypes/${
        (icons && icons.length > 1) ? icons[1] : 'Icon_Empathizer'
      }.png`"
    />
    <div class="label-text blue">
      <span>{{(labels && labels.length > 1) ? labels[1] : 'THE EMPATHIZER'}}</span>
    </div>
  </div>
  <div class="label yellow">
    <div class="label-text yellow">
      <span>{{(labels && labels.length > 2) ? labels[2] : 'THE DRIVER'}}</span>
    </div>
    <img class="label-icon yellow"
      :src="`/static/reports/archetypes/${
        (icons && icons.length > 2) ? icons[2] : 'Icon_Driver'
      }.png`"
    />
  </div>
  <div class="chart-root">
    <svg width="100%" height="100%" viewBox="0 0 100 100">
      <!-- colored filled area graphing the actual values -->
      <polygon :points="buildPoints" fill="none" stroke="white" stroke-width="1.5"></polygon>
      <!-- circles marking vertices -->
      <g>
        <circle
          :cx="graphPoint(n).x"
          :cy="graphPoint(n).y"
          r="2"
          fill="white"
          v-for="n in [0, 1, 2]"
          :key="n"
        >
        </circle>
      </g>
    </svg>
  </div>
</div>
</template>

<script>
export default {
  props: {
    labels: Array, // strings
    icons: Array, // strings
    values: Array, // numbers
    highlightedIndex: Number, // 0 - red, 1 - blue, 2 - yellow
  },
  data() {
    return {
      maxValue: 9,
    };
  },
  computed: {
    buildPoints() {
      if (this.highlightedIndex && !this.highlightedIndex) console.log('reactivity hack');
      return `${this.graphPointPolygon(0)}${this.graphPointPolygon(1)}${this.graphPointPolygon(2)}`;
    },
  },
  methods: {
    graphPoint(i) {
      const value = (this.values && this.values.length > i) ? this.values[i] : ((2 - i) + 6);
      const angle = (Math.PI / 6) - ((Math.PI * 2 / 3) * i);
      const angleMultiplier = value / this.maxValue * (this.highlightedIndex === i ? 61 : 57);
      const x = 50 + Math.cos(angle) * angleMultiplier;
      const y = 66 + Math.sin(angle) * angleMultiplier;
      return { x, y };
    },
    graphPointPolygon(i) {
      const p = this.graphPoint(i);
      return `${Math.round(p.x)},${Math.round(p.y)} `;
    },
  },
  // TODO: do we need a watcher for svg reactivity?
};
</script>

<style lang="scss" scoped>
.almas-radar {
  width: 324.5px;
  height: 283px;
  font-size: 22px;
  background-image: url('/static/reports/almasradar/desaturated.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.chart-root {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.highlight {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.label {
  width: 110%;
  height: 15%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
.label.blue {
  position: absolute;
  left: 67%;
  top: 18%;
}
.label.red {
  position: absolute;
  left: 92%;
  bottom: 18%;
}
.label.yellow {
  position: absolute;
  right: 96%;
  bottom: 18%;
}
.label-text {
  white-space: pre-wrap;
  width: 80%;
}
.label-text.blue {
  text-align: left;
  color: #05968f;
}
.label-text.red {
  text-align: left;
  color: #ea2c2b;
}
.label-text.yellow {
  text-align: right;
  color: #e9a12c;
}
.label-icon {
  width: 20%;
  object-fit: contain;
}
.label-icon.blue {
  filter: brightness(0) saturate(100%)
    invert(38%) sepia(92%) saturate(1108%) hue-rotate(147deg) brightness(86%) contrast(96%);
}
.label-icon.red {
  filter: brightness(0) saturate(100%)
    invert(18%) sepia(77%) saturate(4840%) hue-rotate(352deg) brightness(104%) contrast(84%);
}
.label-icon.yellow {
  filter: brightness(0) saturate(100%)
    invert(59%) sepia(94%) saturate(482%) hue-rotate(346deg) brightness(107%) contrast(83%);
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/AlmasRadar.vue